import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.InputSearchAddressArea");
log.setLevel(log.levels.INFO);

/**
 * InputSearchAddressArea is responsible for:
 * - providing a modal dialog to fill an address
 * - using the OpenStreetMap Nominatim service
 * - send back the position (lat, lng) of the address or null
 */
let InputSearchAddressArea = function () {
    var {Modal} = window.f_mtac_theme;
    var input_search_address_area_modal;

    var location = null; // the center (lng,lat) associated to the address, to be returned
    var name = ""; // the name associated to the address, to be returned and proposed as sitac name
    var $input_search_address_area;

    // Find the language accepted
    const find_best_language = () => {
        let lang = global.configuration.internationalization.language;
        // "en-GB", "fr-CA", ... can be used as is
        if (lang != "en-GB" && lang != "fr-CA" && lang != "pt-PT") {
            // for the others, extract xx from xx-YY
            let code = lang.split("-")[0];
            if (code !== undefined) {
                lang = code;
            }
        }
        log.debug("InputSearchAddressArea.find_best_language", {lang});
        return lang;
    };

    /**
     * Initialisation of the search address feature with the given language
     * @param lg the language
     */
    const init_search = async (lg) => {
        log.debug("InputSearchAddressArea.init_search", {lg});
        const input = $("#input_search_address_area input").val();
        const params = new URLSearchParams();
        const GEOCODING_URI =  new URL("https://nominatim.openstreetmap.org/search");

        params.append("q", input);
        params.append("limit", 10);
        params.append("format", "json");

        // Remove list items (otherwise it is displayed when coming back)
        document.querySelectorAll("#select-address option").forEach((el) => {
            el.parentNode.removeChild(el);
        });
        $("#select-address").css("visibility","hidden");
        document.getElementById("select-address").size = 0;

        await fetch(`${GEOCODING_URI}?${params}`).then((response) => {
            log.debug("InputSearchAddressArea.init_search response ",response);
            response.json().then((result) => {
                log.debug("InputSearchAddressArea.init_search result ",result);
                if (!result === 0) {
                    alert("That query didn't match any geocoding results.");
                    return;
                } else {
                    $("#select-address").css("visibility","visible");
                    var select = document.getElementById("select-address");
                    if (select !== null && select !== undefined) {
                        result.forEach((address) => {
                            log.debug("InputSearchAddressArea.init_search address ",address);    
                            var opt = document.createElement("option");
                            opt.value = [address.lon, address.lat];
                            opt.innerHTML = address.display_name;
                            select.appendChild(opt);
                        });
                        log.debug("InputSearchAddressArea.init_search select.length ", select.length);
                        if (select.length == 0) {
                            document.getElementById("select-address").size = 1; 
                        }
                        else if (select.length <= 2) { 
                            // for 1 and 2
                            // if size = 1, text doesn't carriage return and is not selectable (blue) 
                            // --> force to size = 2
                            document.getElementById("select-address").size = 2; 
                        }
                        else {
                            document.getElementById("select-address").size = 3; 
                        }

                        log.debug("InputSearchAddressArea.init_search size ", document.getElementById("select-address").size);
                        $("#select-address option").addClass("address-item");
                    }
                }
            });
        });
    };

    /**
     * Starts the interaction with the InputAddressAutocompleteArea dialog
     * @returns {Promise<unknown>} location of the place [lng,lat], or null if not found or cancelled
     */
    this.interact = function () {
        $input_search_address_area = document.getElementById("input_search_address_area");
        input_search_address_area_modal = new Modal($input_search_address_area);
        name = "";
        location = null;

        let lang = find_best_language();

        // Prepare DOM elements
        $("#input_search_address_area .modal-title").text(global.internationalization.text("media.Address-to-search"));
        $("#input_search_address_area input").val(""); // empty the input field
        $("#input_search_address_area .invalid-feedback").text(global.internationalization.text("media.Address-not-found"));
        $("#input_search_address_area .invalid-feedback").hide();

        
        // Remove list items (otherwise it is displayed when coming back)
        $("#select-address").css("visibility","hidden");
        document.getElementById("select-address").size = 1;
        document.querySelectorAll("#select-address option").forEach((el) => {
            el.parentNode.removeChild(el);
        });

        // User actions handlers and listeners
        let handlers = {
            ok: () => {
                log.debug("InputSearchAddressArea.interact ok");
                let selected = { coords: $("#select-address").val(), name: $("#select-address")[0][$("#select-address")[0].selectedIndex].text };
                location = [selected.coords.split(",")[0], selected.coords.split(",")[1]];
                name = selected.name;
                input_search_address_area_modal.hide();
            },
            cancel: () => {
                log.debug("InputSearchAddressArea.interact cancel");
                location = null;
                name = "";
                input_search_address_area_modal.hide();
            },
            search: () => {
                log.debug("InputSearchAddressArea.interact search");
                init_search(lang);
                $("#input_search_address_area input").trigger("focus").trigger("select");
                log.debug("InputSearchAddressArea.interact search");
            }
        };

        $input_search_address_area.addEventListener("shown.bs.modal", () => {
            log.debug("InputSearchAddressArea.interact shown.bs.modal");
            $("#input_search_address_area input").trigger("focus").trigger("select");
        });

        $("body").on("keydown", "#input_search_address_area input", async (event) => {
            // Confirm input when the "Enter" key is pressed .
            if (event.key == "Enter") {
                log.debug("InputSearchAddressArea.interact on keydown");
                event.preventDefault();
                handlers["search"]();
            }
        });

        // Call appropriate handler when clicking on [OK] or [Cancel]
        $("body").on("click.input_search_address_area.btn", "#input_search_address_area .btn", (event) => {
            let method = $(event.currentTarget).data("method");
            log.debug(`Pressed ${method} button`);
            handlers[method]();
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                log.debug("InputSearchAddressArea interaction_end");
                // Remove all listeners
                $("body").off("click.input_search_address_area.btn", "#input_search_address_area .btn");
                $input_search_address_area.removeEventListener("shown.bs.modal", () => {});
                $input_search_address_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("#input_search_address_area input").off("focus blur keydown keyup paste input");

                log.debug("Interaction resolved with:", {location, name});
                resolve({location, name});
            };
            log.debug("InputSearchAddressArea Promise");
            $input_search_address_area.addEventListener("hidden.bs.modal", interaction_end);
            input_search_address_area_modal.show();
        });
    };
};

export default new InputSearchAddressArea();
